import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    InstitutionItemCategoryActions,
    ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID,
    ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_SUCCESS,
    ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_FAILURE,
    ACTION_INSTITUTIONITEMCATEGORIES_CLEAR,
    ACTION_INSTITUTIONITEMCATEGORIES_FILTER
} from '../actions/institutionItemCategory';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IInstitutionItemCategoryState {
    formData: Dtos.InstitutionItemCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.InstitutionItemCategory[];
    formLength: number;
}

const initialState: IInstitutionItemCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: IInstitutionItemCategoryState, _isLoading: boolean): IInstitutionItemCategoryState {
    const newState: IInstitutionItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IInstitutionItemCategoryState,
    formData: Dtos.InstitutionItemCategory[],
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IInstitutionItemCategoryState {
    const newState: IInstitutionItemCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IInstitutionItemCategoryState, formFilter: IFormFilter): IInstitutionItemCategoryState {

    const institutionItemCategories: Dtos.InstitutionItemCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = institutionItemCategories ? institutionItemCategories.length : 0;

    const formFilteredData = institutionItemCategories ? institutionItemCategories.filter(p => (formFilter.showInActive) &&
        (formFilter.search == "" || p.institutionItemTemplateCategory.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IInstitutionItemCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function loadFailure(state: IInstitutionItemCategoryState, responseStatus: Dtos.ResponseStatus): IInstitutionItemCategoryState {
    const newState: IInstitutionItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IInstitutionItemCategoryState, propertiesToClear?: string[]): IInstitutionItemCategoryState {

    if (!propertiesToClear) {
        const newState: IInstitutionItemCategoryState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const InstitutionItemCategoryReducer: Reducer<IInstitutionItemCategoryState> = (state: IInstitutionItemCategoryState = initialState, action: InstitutionItemCategoryActions) => {
    switch (action.type) {
        case ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID:
            return loading(state, true);
        case ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_SUCCESS:
            return loadSuccess(state, action.formData, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_INSTITUTIONITEMCATEGORIES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_INSTITUTIONITEMCATEGORIES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default InstitutionItemCategoryReducer;